import Api from "@/Api.js";

export default {

    redeemCouponForIndia(couponCode){
        const url = '/api/secure/purchase/packages?giftCode=' + couponCode;
        return Api.put(url,{});
    },

    redeemCoupon(couponCode){
        const url = '/api/secure/purchase/packages?giftCode=' + couponCode;
        return Api.put(url,{});
    },

    fetchSetup(){
        const url = '/api/setup';
        return Api.get(url);
    }
    


     

}